import { NgModule, inject, provideAppInitializer } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { PgSemanticViewModule } from '../pg-semantic-view/pg-semantic-view.module';

import { PgResourceViewHostDirective, PgResourceEmbedComponent } from './pg-resource-embed/pg-resource-embed.component';
import { PgResourceViewTableComponent } from './pg-resource-view-table/pg-resource-view-table.component';
import { PgResourceViewTableConfigComponent } from './pg-resource-view-table/config/pg-resource-view-table-config.component';
import { PgResourceViewCalendarComponent } from './pg-resource-view-calendar/pg-resource-view-calendar.component';
import { PgResourceViewCalendarConfigComponent } from './pg-resource-view-calendar/config/pg-resource-view-calendar-config.component';
import { PgResourceViewFilesComponent } from './pg-resource-view-files/pg-resource-view-files.component';
import { PgResourcePickerComponent } from './pg-resource-picker/pg-resource-picker.component';
import { PgResourceViewCardsComponent } from './pg-resource-view-cards/pg-resource-view-cards.component';
import { CommonModule } from '@angular/common';
import { PGViewResourceManager } from './resource-view-common';
import { PgUiElementsModule } from '../pg-ui-elements/pg-ui-elements.module';
import { PgUiControlsModule } from '../pg-ui-controls/pg-ui-controls.module';
import { PgUiMoleculesModule } from '../pg-ui-molecules/pg-ui-molecules.module';
import { PgFilePickerComponent } from './pg-file-picker/pg-file-picker.component';
import { PgAttachmentEditorComponent } from './pg-attachment-editor/pg-attachment-editor.component';
import { PgHtmlEditorComponent } from './pg-html-editor/pg-html-editor.component';

import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';

@NgModule({
    declarations: [
        PgResourceEmbedComponent,
        PgResourceViewHostDirective,
        PgResourceViewTableComponent,
        PgResourceViewTableConfigComponent,
        PgResourceViewCalendarComponent,
        PgResourceViewCalendarConfigComponent,
        PgResourceViewFilesComponent,
        PgResourcePickerComponent,
        PgResourceViewCardsComponent,
        PgFilePickerComponent,
        PgAttachmentEditorComponent,
        PgHtmlEditorComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        RouterModule,
        NgbModule,
        PgUiElementsModule,
        PgUiControlsModule,
        PgUiMoleculesModule,
        PgSemanticViewModule,
        EditorModule
    ],
    exports: [
        PgResourceEmbedComponent,
        PgResourceViewTableComponent,
        PgResourceViewTableConfigComponent,
        PgResourceViewCalendarComponent,
        PgResourceViewCalendarConfigComponent,
        PgResourceViewFilesComponent,
        PgResourcePickerComponent,
        PgResourceViewCardsComponent,
        PgFilePickerComponent,
        PgAttachmentEditorComponent,
        PgHtmlEditorComponent
    ],
    providers: [provideAppInitializer(() => {
        const initializerFn = ((PGViewResourceManager: PGViewResourceManager): Function => {
                return async () => {
                    PGViewResourceManager.register('Table', PgResourceViewTableComponent, PgResourceViewTableConfigComponent);
                    PGViewResourceManager.register('Files', PgResourceViewFilesComponent);
                    PGViewResourceManager.register('Cards', PgResourceViewCardsComponent);
                    PGViewResourceManager.register('Calendar', PgResourceViewCalendarComponent, PgResourceViewCalendarConfigComponent);
                };
            })(inject(PGViewResourceManager));
        return initializerFn();
      }),
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'assets/tinymce/tinymce.min.js' }],
    bootstrap: []
})
export class PgResourceViewModule { }
